import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';

import { CRASSSortOptions } from './CrassSortOptions';


export const tableSortOptions: OptionsDictionary = {
  'relevance': SortOptions.relevance,
  'name': SortOptions.name,
  'workbooks': CRASSSortOptions.downstreamWorkbookCount,
  'datasources': CRASSSortOptions.downstreamDataSourceCount,
  'containerName': CRASSSortOptions.containerName,
};